<template>
  <mds-modal
    size="large"
    :width="'1200px'"
    aria-label="Large Modal"
    v-model="isopenModel"
    title=""
    action-required
  >
    <tool-advance-filter
      :filterInfo="filterInfo"
      :filterOptions="filterOptions"
      @onFilterSelected="onFilterSelected"
      @buttonclick="genericMethodClick"
    >
      <template #dynamic-content v-if="selectedComponent != ''">
        <component
          ref="filtercontent"
          :is="selectedComponent"
          :baselineData="baselineFilterObject"
          @resetBaselineData="resetBaselineData"
          @openErrorTab="openErrorTab"
        ></component>
      </template>
    </tool-advance-filter>
  </mds-modal>
</template>
<script>
import { ToolAdvanceFilter } from "../../component/tool";
import MdsModal from "@mds/modal";
import InvestmentReturnFilter from "./investment-return-filter.vue";
import InvestmentWithdrawalFilter from "./investment-withdrawal-filter.vue";
import InvestmentContributionFilter from "./investment-contribution-filter";
import InvestmentMaturityFilter from "./investment-maturity-filter";
import InvestmentMarketcrashFilter from "./investment-marketcrash-filter";
import { CommonHelper } from "../../helpers";
import MonthPickerTest from "./month-picker-test.vue";
import {
  AdvanceInvestmentFilter,
  AdvanceFilterInvestmentComponetName,
} from "../../helpers/constant";
import { InvestmentEngagementTool } from "../../mixin";

export default {
  props: {
    isopenModel: {
      type: Boolean,
    },
    baselineData: {
      type: Object,
    },
    openTabName: {
      type: String,
    },
  },
  mixins: [InvestmentEngagementTool],
  components: {
    ToolAdvanceFilter,
    InvestmentReturnFilter,
    InvestmentWithdrawalFilter,
    InvestmentContributionFilter,
    InvestmentMaturityFilter,
    MdsModal,
    InvestmentMarketcrashFilter,
    MonthPickerTest,
  },
  data() {
    return {
      selectedValue:
        this.openTabName == AdvanceFilterInvestmentComponetName.Return
          ? AdvanceInvestmentFilter.Return
          : this.openTabName == AdvanceFilterInvestmentComponetName.Contribution
          ? AdvanceInvestmentFilter.Contribution
          : this.openTabName == AdvanceFilterInvestmentComponetName.Withdrawal
          ? AdvanceInvestmentFilter.Withdrawal
          : this.openTabName == AdvanceFilterInvestmentComponetName.Maturity
          ? AdvanceInvestmentFilter.Maturity
          : this.openTabName == AdvanceFilterInvestmentComponetName.MarketCrash
          ? AdvanceInvestmentFilter.MarketCrash
          : this.openTabName ==
            AdvanceFilterInvestmentComponetName.MonthPickerTest
          ? AdvanceInvestmentFilter.MonthPickerTest
          : 0,
      baselineFilterObject: Object.assign({}, this.baselineData),
      selectedComponent: this.openTabName,
      filterInfo: {
        title: "Advanced Setting",
        borderPosition: "bottom",
        actionButtons: [
          {
            method: "closeAdvancedFilter",
            variation: "secondary",
            text: "Cancel",
            id: "investmentAdvancedFilter_2",
          },
          {
            method: "applyAdvancedSetting",
            variation: "primary",
            text: "Apply Changes",
            id: "investmentAdvancedFilter_1",
          },
        ],
      },
    };
  },
  mounted() {},

  computed: {
    filterOptions() {
      let selectedOption = this.selectedValue;
      return [
        {
          id: "filterOption_1",
          active: selectedOption == 1,
          text: "Return",
          value: AdvanceInvestmentFilter.Return,
        },
        {
          id: "filterOption_2",
          active: selectedOption == 2,
          text: "Contribution",
          value: AdvanceInvestmentFilter.Contribution,
        },
        {
          id: "filterOption_3",
          active: selectedOption == 3,
          text: "Withdrawals",
          value: AdvanceInvestmentFilter.Withdrawal,
        },
        {
          id: "filterOption_5",
          active: selectedOption == 5,
          text: "Market Crash",
          value: AdvanceInvestmentFilter.MarketCrash,
        },
        {
          id: "filterOption_4",
          active: selectedOption == 4,
          text: "Maturity Date",
          value: AdvanceInvestmentFilter.Maturity,
        },

        // {
        //   id: "filterOption_6",
        //   active: selectedOption == 6,
        //   text: "Date Picker",
        //   value: AdvanceInvestmentFilter.MonthPickerTest,
        // },
      ];
    },
  },

  async created() {},
  methods: {
    openErrorTab(tabId) {
      this.selectedValue = tabId;
      this.openTab();
    },
    resetBaselineData(changedBaselineObject) {
      this.baselineFilterObject = changedBaselineObject;
    },
    genericMethodClick(function_name) {
      this[function_name]();
    },
    getvalue(data) {
      if (data == undefined) return 0;
      else return data.value;
    },
    async applyAdvancedSetting() {
      let iserrorPresentInCurrentTab;
      if (
        this.selectedValue != AdvanceInvestmentFilter.Maturity &&
        this.selectedValue != AdvanceInvestmentFilter.MonthPickerTest
      ) {
        this.$refs.filtercontent.fillInvestmentModel(this.selectedValue);
        iserrorPresentInCurrentTab = this.$refs.filtercontent.validations(
          this.baselineFilterObject.advancedetails,
          this.selectedValue
        );
        if (iserrorPresentInCurrentTab) {
          return;
        }
        let isErrorPresent =
          this.$refs.filtercontent.IsAnyInvOptionHaveInvalidData(
            this.baselineFilterObject.Errors
          );
        if (isErrorPresent) {
          return;
        }
      }
      if (
        this.baselineFilterObject.Errors.Return.length == 0 &&
        this.baselineFilterObject.Errors.Contribution.length == 0 &&
        this.baselineFilterObject.Errors.Withdrawal.length == 0 &&
        this.baselineFilterObject.Errors.MarketCrash.length == 0
      ) {
        let newAdvanceDetails = CommonHelper.ConvertObjectIntoApiModel(
          this.baselineFilterObject.advancedetails
        );
        let currentObject = Object.assign([], this.baselineFilterObject);
        currentObject.advancedetails = newAdvanceDetails;

        this.$emit("saveData", currentObject);
      }
    },
    closeAdvancedFilter() {
      this.selectedValue = AdvanceInvestmentFilter.Return;
      this.selectedComponent = AdvanceFilterInvestmentComponetName.Return;
      this.$emit("closeModel");
    },
    openTab() {
      if (this.selectedValue == AdvanceInvestmentFilter.Return) {
        this.selectedComponent = AdvanceFilterInvestmentComponetName.Return;
      } else if (this.selectedValue == AdvanceInvestmentFilter.Contribution) {
        this.selectedComponent =
          AdvanceFilterInvestmentComponetName.Contribution;
      } else if (this.selectedValue == AdvanceInvestmentFilter.Withdrawal) {
        this.selectedComponent = AdvanceFilterInvestmentComponetName.Withdrawal;
      } else if (this.selectedValue == AdvanceInvestmentFilter.Maturity) {
        this.selectedComponent = AdvanceFilterInvestmentComponetName.Maturity;
      } else if (this.selectedValue == AdvanceInvestmentFilter.MarketCrash) {
        this.selectedComponent =
          AdvanceFilterInvestmentComponetName.MarketCrash;
      } else if (
        this.selectedValue == AdvanceInvestmentFilter.MonthPickerTest
      ) {
        this.selectedComponent =
          AdvanceFilterInvestmentComponetName.MonthPickerTest;
      }
    },
    onFilterSelected(filterOption) {
      this.selectedValue = filterOption.value;
      this.openTab();
    },
  },
};
</script>
<style lang="scss" module></style>
